import { resolveNamesToIds } from 'components/specialist/AttentionVoucher/AddAttentionVoucherForm/resolveNamesToIds';

// Arma el payload `tasks[]` que consumen POST /orders/from-budget
// (generateOrderFromBudget) y PUT (updateOrderFromBudget).
//
// Plan trazabilidad-equipos Fase 4: cada tarea declara su equipo con
// `id_ascensores[]` (FK canonical → escribe N:M order_item_ascensor, deja
// elevator NULL) cuando el nombre resuelve contra el catálogo del cliente, o
// con `elevator: <nombre>` (legacy CSV) como fallback si el catálogo no cargó o
// el nombre es texto libre histórico que no matchea.
//
// Expansión multi-ascensor: una tarea con N ubicaciones se clona en N tareas
// con un equipo singular cada una. En modo edición, la primera clonación
// preserva el `id` original (update del item existente); las adicionales quedan
// sin id → create. Esto calza con el merge de updateOrderFromBudget y el create
// de generateOrderFromBudget.
//
// @param {Array} tasks - filas del Form.List (`values.tasks`).
// @param {Array<{nombre:string,id:number}>} clientAscensores - catálogo del cliente.
// @param {boolean} isEdit - modo edición (preserva `id` en la primera clonación).
// @returns {Array} payload de tareas listo para el endpoint.
export function buildOrderTasksPayload(tasks, clientAscensores, isEdit) {
  const payload = [];
  for (const t of tasks || []) {
    const elevators = Array.isArray(t.elevator) ? t.elevator : t.elevator ? [t.elevator] : [];
    if (elevators.length === 0) continue;
    elevators.forEach((elev, clonIdx) => {
      const { ids, allResolved } = resolveNamesToIds([elev], clientAscensores);
      payload.push({
        ...(isEdit && clonIdx === 0 && typeof t.id === 'number' ? { id: t.id } : {}),
        description: t.description,
        ...(allResolved && ids.length > 0 ? { id_ascensores: ids } : { elevator: elev }),
        id_hallazgo: t.id_hallazgo ?? null,
        id_coleccion_item: t.id_coleccion_item ?? null,
        cantidad: Number(t.cantidad || 1),
        // Orden explícito de la tarea (nivel simple de planificación). Contador
        // global 0-based sobre el resultado final: las clonaciones por ascensor
        // se numeran secuencialmente, no comparten el índice de la fila origen.
        sort_order: payload.length,
      });
    });
  }
  return payload;
}
